<template>
    <div>
        <template v-if="location">
            <google-map id="map" ref="Map" :zoom="12" :center="location">
                <google-map-marker
                :position="location"
                :icon="'/assets/web/images/marker_' + base_category + '.png'"
            />
            </google-map>
        </template>
    </div>
</template>

<script>
export default {
    props: ['location', 'base_category'],
}
</script>